import React, { useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { MRTLocale } from './../../../i18n/mrt-locale.js';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton, MRT_ToggleGlobalFilterButton } from 'material-react-table';
import ButtonTooltipTable from '../common/buttons/ButtonTooltipTable.jsx';
import { backYouTheme } from '../../../theme';

export default function TableLoader({
	lines = 20,
	...props
}) {
	const columns = useMemo(() => ([
		{ id: '1', header: '======='},
		{ id: '2', header: '======='},
		{ id: '3', header: '======='},
		{ id: '4', header: '======='},
		{ id: '5', header: '======='},
		{ id: '6', header: '======='},
		{ id: '7', header: '======='},
	]), []);

	const tableTheme = useMemo(() =>
		createTheme({
			palette: {
				primary: backYouTheme.palette.primary,
				secondary: backYouTheme.palette.secondary,
				warning: {
					main: '#F0672F',
				},
				info: {
					main: '#D8DFE0'
				}
			},
			typography: backYouTheme.typography
		}),
	[backYouTheme]);

	const table = useMaterialReactTable({
		...props,
		state: { showProgressBars: true, showSkeletons: true },
		initialState: { density: 'compact', pagination: { pageIndex: 0, pageSize: lines } },
		columns,
		data: [],
		enableDensityToggle: false,
		rowsPerPage: [lines],
		localization: MRTLocale[ENV.lang],
		muiSkeletonProps: {
			animation: 'pulse',
			height: 20
		},
		muiTablePaperProps: {
			elevation: 0,
			sx: {
				borderRadius: '0.38rem!important',
				overflow: 'hidden'
			}
		},
		muiTableContainerProps: {
			sx: {
				maxHeight: '64vh',
				'::-webkit-scrollbar': {
					'width': '.4rem',
					'height': '.4rem'
				},
				'::-webkit-scrollbar-thumb': {
					'backgroundColor': '#AAAAAA',
					'borderRadius': '50px'
				},
				'.MuiTableHead-root': {
					filter: 'blur(3px)',
					color: '#9E9E9E !important',
					opacity: '0.35'
				}
			}
		},
		muiLinearProgressProps: ({ isTopToolbar }) => ({
			sx: {
				display: isTopToolbar ? 'block' : 'none',
				height: '5px'
			}
		}),
		renderToolbarInternalActions: ({ table }) => (
			<div style={{ opacity: '0.7', pointerEvents: 'none' }}>
				<MRT_ToggleGlobalFilterButton table={table} />
				<MRT_ToggleFiltersButton table={table} />
				<ButtonTooltipTable table={table} />
				<MRT_ToggleFullScreenButton table={table} />
			</div>
		)
	});

	return (
		<ThemeProvider theme={tableTheme}>
			<MaterialReactTable table={table}/>
		</ThemeProvider>
	);
}